import { Component, Input } from '@angular/core';
import { GetSurveyPerformanceReportResult } from '../survey-performance-reporta.interface';

@Component({
  selector: 'ps-survey-performance-report-table',
  templateUrl: './survey-performance-report-table.component.html',
  styleUrls: ['./survey-performance-report-table.component.css'],
})
export class SurveyPerformanceReportTableComponent {
  constructor() {}
  @Input()
  public dataList: Array<GetSurveyPerformanceReportResult> = [];
}
